import './modal.sass';

export { default } from './modal';
